import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import { useParams } from 'react-router-dom'
import './index.scss'
import { Link } from 'react-router-dom'

const queryString = require('query-string')

function titleName(id) {
  let titlename = ''
  let titlename1 = ''
  if (id == 1) {
    titlename = '喜讯！锐控高端光电编码器芯片成功实现量产'
    titlename1 = '喜讯'
  }
  document.title = titlename + '_北京锐控自动化科技有限公司'

  return titlename1
}
export default function () {
  const { id } = useParams()

  return (
    <div style={{ background: '#f6f6f6' }}>
      <Header></Header>
      <div className="journalism">
        <div className="journalism-solution">
          <div className="journalism-solution-item"> 当前位置： </div>
          <div className="journalism-solution-item"> 首页 > </div>
          <div className="journalism-solution-item">新闻中心 > </div>
          <div className="journalism-solution-item" style={{ color: '#2176D0' }}>
            {titleName(id)}
          </div>
        </div>
        <div className="journalism-content">
          <div className="journalism-content-h1" style={{ paddingBottom: '.457143rem ' }}>
            <div className="journalism-content-h1-text">喜讯！锐控高端光电编码器芯片成功实现量产</div>
            <div className="journalism-content-h1-time">2023-03-18</div>
          </div>

          {/* 厂区安全生产监测解决方案 */}
          <div className="journalism-content-details2">
            <div className="journalism-content-details2-text"> 　　光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
            <div className="journalism-content-details2-text"> 　　锐控团队经过严苛的光学设计、光电芯片设计、流片工艺研发、封装测试等各环节的流程把控，于2023年3月正式宣布，其TV-PA3911-C、TV-OEC-FB和TV-OEC-A型号的光电编码器芯片及编码器信号调理芯片成功实现量产。此次量产的编码器芯片，具有高精度、安全可靠、性能稳定、减少串扰等技术突破。采用“5通道光学游标编码差分扫描技术”输出模拟正弦/余弦波信号，精度达到2048 CPR，支持26位高精度光电编码器系统。该系列芯片采用先进的封装技术，具有较强的机械性能、良好的电气性能和散热性能，保证了芯片正常工作的高稳定性和可靠性。同时带有温度过高保护系统，可以对反向电源电压进行保护。</div>
            <div className="journalism-content-details2-img">
              <div className="journalism-content-details2-img-item"></div>
              <div className="journalism-content-details2-img-item"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

// export default class index extends Component {
//   componentWillMount() {

//   }
//   render() {
//     return (
//       <div style={{ background: '#f6f6f6' }}>
//         <Header></Header>
//         <div className="journalism">
//           <div className="journalism-solution">
//             <div className="journalism-solution-item"> 当前位置：</div>
//             <div className="journalism-solution-item"> 首页 ></div>
//             <div className="journalism-solution-item">产品中心 ></div>
//             <div className="journalism-solution-item"> 解决方案 > </div>
//             <div className="journalism-solution-item"> 解决方案 > </div>
//           </div>
//           <div className="journalism-content">
//             <div className="journalism-content-h1">智能井盖解决方案</div>
//             <div className="journalism-content-details">
//               <div className="journalism-content-details-item">
//                 <div className="journalism-content-details-item-img"></div>
//                 <div className="journalism-content-details-item-title">系统概述</div>
//                 <div className="journalism-content-details-item-test">RS485通讯采用标准的MODBUS通讯协议，通信接口的远程数据采集方法，可实现通信距离几十米到上千米, 适用于管廊、电力隧道等有外部供电的自动化系统。</div>
//                 <div className="journalism-content-details-item-title">主要功能</div>
//                 <div className="journalism-content-details-item-test">NB-IOT物联网通讯是IoT领域一个新兴的技术，支持低功耗设备在广域网的蜂窝数据连接，也被叫作低功耗广域网(LPWAN)。</div>
//               </div>
//               <div className="journalism-content-details-item">
//                 <div className="journalism-content-details-item-img"></div>
//                 <div className="journalism-content-details-item-title">系统概述</div>
//                 <div className="journalism-content-details-item-test2">本公司智能井盖云平台，结合网络技术、信息技术、整合技术、管理平台技术、应用技术等，将智能井盖、各类传感器、管理人员和维护人员通过无线的方式连接在一起，云端存取数据、数据比对、逻辑判断，可完成设备监控、报警记录、趋势分析、报警推送、派单维修、后台管理等功能，能够及时发现报警并定位，随时随地可进行监测、派单维修。界面操作简洁高效，事件记录清晰完整，产品设计结合智慧城市管理规范，满足智慧城市的各项管理需求。</div>
//               </div>
//             </div>

//             <div className="journalism-content-option">联系我们</div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     )
//   }
// }
